export default function (app, context) {
  const { allRequireContext } = context;

  app.config.globalProperties.allRequireContext = allRequireContext;
  app.provide("allRequireContext", allRequireContext);
}
